export default "__VITE_ASSET__DcrUHb$T__"